<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.16667 3.3335C8.08268 3.3335 7.16797 4.03337 6.82292 5.00016H5.88542L2.78646 15.0002C2.60091 15.521 2.5 16.0841 2.5 16.6668C2.5 19.4175 4.74935 21.6668 7.5 21.6668C9.38477 21.6668 11.0482 20.6121 11.901 19.0627C12.0866 19.1343 12.2884 19.1668 12.5 19.1668C12.7116 19.1668 12.9134 19.1343 13.099 19.0627C13.9518 20.6121 15.6152 21.6668 17.5 21.6668C20.2507 21.6668 22.5 19.4175 22.5 16.6668C22.5 15.7554 22.2559 14.9058 21.8229 14.1668L19.1146 5.00016H18.1771C17.832 4.03337 16.9173 3.3335 15.8333 3.3335C14.7493 3.3335 13.8346 4.03337 13.4896 5.00016H11.5104C11.1654 4.03337 10.2507 3.3335 9.16667 3.3335ZM7.50052 13.3335C9.35273 13.3335 10.8339 14.8146 10.8339 16.6668C10.8339 18.519 9.35273 20.0002 7.50052 20.0002C5.64831 20.0002 4.16719 18.519 4.16719 16.6668C4.16719 14.8146 5.64831 13.3335 7.50052 13.3335ZM20.8339 16.6668C20.8339 14.8146 19.3527 13.3335 17.5005 13.3335C15.6483 13.3335 14.1672 14.8146 14.1672 16.6668C14.1672 18.519 15.6483 20.0002 17.5005 20.0002C19.3527 20.0002 20.8339 18.519 20.8339 16.6668Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgBinoculars',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>